import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReadListComponent } from './read-list.component';
import { ReadListModalService } from './read-list.service';
import { ReadListRoutingModule } from './read-list-routing.module';
import { ReadListModalComponent } from './read-list-modal.component';
import { FormsModule } from '@angular/forms';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslationModule } from '@schoolbelle/common/translation';


import { ReadListTableModule } from './charts/read-list-table/read-list-table.module';
import { ChartsCarouselModule } from './charts/carousel/charts-carousel.module';
import { TrackFocusModule } from '@schoolbelle/shared/directives';

@NgModule({
  imports: [
    CommonModule,
    ReadListRoutingModule,
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    FormsModule,
    TranslationModule.forRoot(),

    ChartsCarouselModule, 
    ReadListTableModule,
    TrackFocusModule,

  ],
  providers:[ReadListModalService],
  declarations: [ReadListComponent, ReadListModalComponent],
  entryComponents:[ReadListComponent, ReadListModalComponent],
})
export class ReadListModalModule { }
